import { useLanguage } from '../context/LanguageContext';

export default function PrivacyPage() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[hsl(38,44%,96%)]">
      <section className="bg-[hsl(20,17%,12%)] text-white py-16 sm:py-20">
        <div className="mx-auto max-w-[72rem] px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-[family-name:var(--font-display)] text-3xl sm:text-4xl lg:text-5xl tracking-[var(--tracking-display)]">{t('privacy')}</h1>
        </div>
      </section>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl p-6 sm:p-8 border border-[hsl(32,17%,84%)] space-y-8">
          <div>
            <h2 className="font-[family-name:var(--font-display)] text-xl mb-4">Datenschutzerklärung</h2>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Wir freuen uns über Ihren Besuch auf unserer Website. Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie über die Verarbeitung Ihrer Daten.
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">1. Verantwortlicher</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Ermal Sinanaj<br />
              Little Italy Ristorante<br />
              Alter Markt 6, 69412 Eberbach<br />
              E-Mail: info@little-italy-ristorante.de<br />
              Telefon: 0179 / 700 79 58
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">2. Erhebung und Verarbeitung personenbezogener Daten</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Beim Besuch unserer Website werden automatisch Informationen allgemeiner Natur erfasst (z. B. Browsertyp, Betriebssystem, Zugriffszeit). Diese Daten lassen keine Rückschlüsse auf Ihre Person zu und dienen der Sicherstellung eines störungsfreien Betriebs unserer Website.
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">3. Reservierungen und Bestellungen</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Wenn Sie eine Tischreservierung vornehmen oder eine Bestellung aufgeben, erheben wir die von Ihnen angegebenen Daten (Name, Telefonnummer, E-Mail-Adresse) ausschließlich zur Bearbeitung Ihrer Anfrage. Die Daten werden nicht an Dritte weitergegeben und nach Abschluss des Vorgangs gemäß den gesetzlichen Aufbewahrungsfristen gespeichert.
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">4. Kontaktaufnahme</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Bei der Kontaktaufnahme über unser Kontaktformular werden die von Ihnen mitgeteilten Daten zur Bearbeitung Ihrer Anfrage gespeichert. Eine Weitergabe an Dritte erfolgt nicht.
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">5. Ihre Rechte</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger sowie den Zweck der Datenverarbeitung. Darüber hinaus haben Sie das Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">6. Cookies</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Unsere Website verwendet technisch notwendige Cookies, um die Funktionalität der Website sicherzustellen (z. B. Spracheinstellung). Diese Cookies werden auf Ihrem Endgerät gespeichert und nach Ablauf der Sitzung automatisch gelöscht.
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">7. Änderungen dieser Datenschutzerklärung</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
